import React, { memo } from 'react';

import { constants, useAccountNumbersField, useAccountNumbersValidation } from '@atlas/core';
import { Errors, Label, Select } from '@atlas/ui';

import useTranslate from 'common/I18n/Interpreter';

const { ACCOUNT_TYPE } = constants;

const AccountNumberFieldDropdown = ({ fieldIndex, hint, name, readOnly }) => {
  const t = useTranslate();
  const defaultLabel = t('choose_an_option');

  const options = [
    { disabled: true, text: defaultLabel, value: '' },
    { text: t('account_type_current_account'), value: ACCOUNT_TYPE.CONTACORRENTE },
    { text: t('account_type_savings_account'), value: ACCOUNT_TYPE.CONTAPOUPANCA },
    { text: t('account_type_salary_account'), value: ACCOUNT_TYPE.CONTASALARIO },
    { text: t('account_type_payment_account'), value: ACCOUNT_TYPE.CONTAPAGAMENTO },
  ];

  const { errors, isError, isTouched, label, onChangeDropdown, onFocus, value } =
    useAccountNumbersField({
      fieldIndex,
      name,
    });

  useAccountNumbersValidation({ fieldIndex, isTouched, name });

  return (
    <div className="account-number-form__inner required">
      <Select
        disabled={readOnly}
        error={isError}
        label={label}
        onChange={onChangeDropdown}
        onFocus={onFocus}
        options={options}
        value={value}
      />

      {isError ? (
        <Errors errors={errors.map(({ message, params }) => ({ message, params }))} />
      ) : (
        <Label className="hint" message={hint} />
      )}
    </div>
  );
};

export default memo(AccountNumberFieldDropdown);
